<template>
  <div>
    <div class="workthumb">
      <router-link :to="{ name: 'trabalho', params: { 'slug': slug }}">
        <img :src="this.newURL" :alt="name" :title="name" />
      </router-link>
      <h1 class="workthumb__name">
        <router-link :to="{ name: 'trabalho', params: { 'slug': slug }}" v-html="name"></router-link>
      </h1>
      <div class="workthumb__tags">
        <div class="workthumb__tag">
          <span v-html="client"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.image.substring(this.image.lastIndexOf(".")) != ".gif") {
      this.newURL =
        this.image.substring(0, this.image.lastIndexOf(".")) +
        "-360x360" +
        this.image.substring(this.image.lastIndexOf("."));
    } else {
      this.newURL = this.image;
    }
  },
  name: "workthumb",
  props: {
    name: {
      type: String,
      required: true
    },
    client: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  data: () => ({
    newURL: ""
  }),
  methods: {
    isNotLastWork(index) {
      return this.tags.length > index + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";
.workthumb {
  img {
    border-radius: 0.9rem;
    width: 100%;
    height: auto;
  }
  &__name {
    font-weight: 900;
    font-size: 2.5rem;
    margin: 1.5rem 0 0.3rem;
    @media (max-width: $max-sm) {
      font-size: 1.7rem;
    }
    a {
      text-decoration: none;
      color: inherit;
    }
  }
  &__tags {
    font-size: 1.7rem;
    color: #9b9b9b;
    @media (max-width: $max-sm) {
      font-size: 1.4rem;
    }
  }
  &__tag {
    display: inline;
  }
}
</style>
